import Parse from "parse";
import { useEffect, useState } from "react";
import { Wheelchair_Boarding } from "../js/parsegenerated";

/**
 *
 * @returns All valid values for wheelchair boarding settings.
 */
export function useWheelchairBoarding(presetcondition: string) {
  const [wheelchair, setWheelchair] = useState<Wheelchair_Boarding[]>([]);
  const [condition, setCondition] = useState<string>(
    presetcondition ? presetcondition : ""
  );
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Wheelchair_Boarding)
      .equalTo("condition", condition)
      .find()
      .then(setWheelchair);
  }, [reload]);

  return [
    wheelchair,
    (condition) => {
      setCondition(condition);
      setReload((x) => x + 1);
    },
  ] as [Wheelchair_Boarding[], (condition) => void];
}
